// src/components/ui/Card/Card.jsx
// 简化过度抽象的API，保持基础结构

import React from 'react';
import styles from './Card.module.css';

const Card = ({
  children,
  variant = 'default',  // default, glass, interactive
  className,
  onClick,
  // 过滤掉自定义属性，防止传递到DOM
  interactive,
  hover,
  ...props
}) => {
  // 构建CSS类名
  const cardClasses = [
    styles.card,
    styles[variant],
    onClick && styles.clickable,
    interactive && styles.interactive,
    hover && styles.hover,
    className
  ].filter(Boolean).join(' ');

  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      className={cardClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
};

// 简化的子组件 - 直接在主文件中定义
const CardHeader = ({ children, className }) => (
  <div className={`${styles.header} ${className || ''}`}>
    {children}
  </div>
);

const CardBody = ({ children, className, padding = true }) => (
  <div className={`${styles.body} ${!padding ? styles.noPadding : ''} ${className || ''}`}>
    {children}
  </div>
);

const CardFooter = ({ children, className }) => (
  <div className={`${styles.footer} ${className || ''}`}>
    {children}
  </div>
);

// 导出所有组件
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;